import {Helmet} from "react-helmet";
import {RouteInfo} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import React, {useEffect, useState} from "react";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import RaikoDefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/RaikoDefaultDialogPage";
import RaikoCustomTable from "../../raikoComponents/raikoCustomTable/RaikoCustomTable";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import RaikoCustomSimpleActiveDeActiveChip
    from "../../raikoComponents/raikoCustomChip/raikoCustomSimpleActiveDeactiveChip/RaikoCustomSimpleActiveDeActiveChip";
import AddNewSlider from "../../component/slider/AddNewSlider";
import {SliderService} from "../../serverService/sliderService/SliderService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {useNavigate} from "react-router-dom";

export default function SlidersList() {

    const size = 15;
    let page = 0;

    const service = new SliderService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())

    const navigate = useNavigate()

    useEffect(() => {
        if (typeof service !== "undefined") {
            getDataFromServer()
        }
    }, [])

    function prepareTableItem(id, number, title, creator, createdDate, publishedState) {
        return {
            id,
            number,
            title,
            creator,
            createdDate: convertUniversalDateToPersianDate(createdDate),
            publishedState: <RaikoCustomSimpleActiveDeActiveChip deActiveStateTitle={"منتشر نشده"}
                                                                 activeStateTitle={"منتشر شده"} state={publishedState}/>
        }
    }

    const [tableList, setTableList] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);

    const [addNewSliderDialog, setAddNewSliderDialog] = useState(false);

    function openAddDialog() {
        setAddNewSliderDialog(true)
    }

    function closeAddDialog() {
        setAddNewSliderDialog(false)
    }


    function handlePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function handleShowDetail(rowId) {
        navigate(RouteInfo.SliderDetail.globalUrl.replace(":id", rowId))
    }

    function getDataFromServer() {
        setTableLoading(true)
        service.getSliderList(page, size)
            .then(response => {
                setTableList([])
                setPageCount(response.totalPage)
                response.data.map((item, index) => {
                    setTableList(prevState => [
                        ...prevState,
                        prepareTableItem(
                            item.id,
                            (page * size) + index + 1,
                            item.type ? item.type.persianName : "-",
                            item.createdBy,
                            item.createdAt,
                            item.published
                        )
                    ])
                })
                setTableLoading(false)
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت لیست اسلایدر ها"))
            setTableLoading(false)

        })
    }


    function handleAddItemToSlider(newValue) {
        if (page === 0) {
            const _tableList = tableList
            setTableList([])
            _tableList.map((item, index) => {

                if (index === 0) {
                    setTableList([
                        prepareTableItem(
                            newValue.id,
                            1,
                            newValue.type ? newValue.type.persianName : "-",
                            newValue.createdBy,
                            newValue.createdAt,
                            newValue.published
                        )
                    ])
                }

                setTableList(prevState => [
                    ...prevState,
                    {
                        ...item,
                        number: (page * size) + index + 2
                    }
                ])
            })
        }
    }

    return (
        <>
            <Helmet>
                <title>{RouteInfo.SliderList.name}</title>
            </Helmet>

            <RaikoDefaultDialogPage
                dialogSize={DialogSize.WRAP_CONTENT}
                onClose={closeAddDialog}
                open={addNewSliderDialog}
                pageTitle={"اسلایدر جدید"}
            >
                <AddNewSlider
                    handleAddItem={handleAddItemToSlider}
                    handleCloseDialog={_ => {
                        closeAddDialog()
                    }}
                />

            </RaikoDefaultDialogPage>


            <section
                className={css`
                  padding: 26px 0;
                  overflow: hidden;
                `}>

                <RaikoBreadcrumb
                    breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            "اسلایدر",
                            ""
                        ),
                        raikoBreadCrumbItemGenerator(
                            "اسلایدر ها",
                            RouteInfo.SliderList.globalUrl
                        ),
                    ]}
                />

                <RaikoBaseCardContainer
                    className={`${css`
                      margin-top: 40px;
                    `}`}>


                    <ButtonDivisionSection>
                        <ButtonPrimaryRaiko
                            label={"افزودن"}
                            className={css`
                              height: max-content !important;
                            `}
                            onClick={openAddDialog}
                        />
                    </ButtonDivisionSection>

                    <div className={css`
                      width: 100%;
                      margin-top: 1rem;
                      overflow-x: scroll !important;
                    `}>
                        <RaikoCustomTable
                            data={tableList}
                            header={columns}
                            isLoading={tableLoading}
                            pageCount={pageCount}
                            handlePaginationChange={handlePagination}
                            rowClicked={handleShowDetail}
                        />
                    </div>


                </RaikoBaseCardContainer>

            </section>

        </>
    )
}

const columns = [
    {
        id: 'number',
        label: '#'
    }, {
        id: 'title',
        label: 'عنوان'
    }, {
        id: 'createdDate',
        label: 'تاریخ ساخت'
    }, {
        id: 'creator',
        label: 'سازنده',
    }, {
        id: 'publishedState',
        label: 'وضعیت انتشار',
    },
];